import PropTypes from 'prop-types'
import { shallowEqual, useSelector } from 'react-redux'
import { ADMIN, CONSULT, GEST, TECH } from '../../administration/components/user/constants/HabilitationConstants'

const HabilitationRequired = ({
    habilitation: {
        required = [],
        atLeastOne = [],
        requiredRoles = [],
        forbiddenRoles = [],
    },
    user,
    userHabs,
    children,
}) => {
    const {
        accountUserReducer,
        accountHabilitationsReducer,
    } = useSelector(store => ({
        accountUserReducer: store.AccountReducer.accountUser,
        accountHabilitationsReducer: store.AccountReducer.accountHabilitations,
    }), shallowEqual)

    const accountUser = user ?? accountUserReducer
    const accountHabilitations = userHabs ?? accountHabilitationsReducer

    const requiredValid = required.every(c => accountHabilitations.some(h => h.habilitation === c))
    const atLeastOneValid = !atLeastOne.length || atLeastOne.some(c => accountHabilitations.some(h => h.habilitation === c))

    const functionTestRole = role => {
        return role === ADMIN && accountUser.isAdmin === '1'
            || role === GEST && accountUser.metadata === '1'
            || role === TECH && accountUser.labo === '1'
            || role === CONSULT && accountUser.consultant === '1'
    }

    const requiredRolesValid = !requiredRoles.length || requiredRoles.some(functionTestRole)
    const forbiddenRolesValid = !forbiddenRoles.some(functionTestRole)

    return requiredValid && atLeastOneValid && requiredRolesValid && forbiddenRolesValid && children
}

HabilitationRequired.propTypes = {
    habilitation: PropTypes.shape({
        required: PropTypes.arrayOf(PropTypes.string),
        atLeastOne: PropTypes.arrayOf(PropTypes.string),
        isAdminNeeded: PropTypes.bool,
        isAdminAllowed: PropTypes.bool,
    }).isRequired,
    user: PropTypes.shape({}),
    userHabs: PropTypes.arrayOf(PropTypes.shape({})),
    children: PropTypes.element.isRequired,
}

export default HabilitationRequired